import { useState, useEffect } from 'react'
import mercadolibreService from '../../../services/mercadolibreService'
import { MercadoLibreTokenStatus } from '../types/mercadolibre'

export const useMercadoLibreTokenStatus = () => {
  const [tokenStatus, setTokenStatus] = useState<MercadoLibreTokenStatus | null>(null)
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState<string | null>(null)

  const loadTokenStatus = async () => {
    try {
      setIsLoading(true)
      setError(null)
      const response = await mercadolibreService.getTokenStatus()
      setTokenStatus(response)
    } catch (err: any) {
      setError(err.response?.data?.message || 'Error al cargar el estado del token')
    } finally {
      setIsLoading(false)
    }
  }

  const clearError = () => setError(null)

  // Cargar estado del token al montar el componente
  useEffect(() => {
    loadTokenStatus()
  }, [])

  return {
    tokenStatus,
    isLoading,
    error,
    loadTokenStatus,
    clearError
  }
}
